import React, { useEffect, useReducer, useState } from 'react';
import { Navigate, useRoutes, useLocation, Outlet } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import AuthNavbar from 'components/Navbars/AuthNavbar.js';
import Footer from 'components/Footer/Footer.js';

import styles from 'assets/jss/material-dashboard-pro-react/layouts/authStyle.js';

import register from 'assets/img/register.jpeg';
import login from 'assets/img/login.jpeg';
import lock from 'assets/img/lock.jpeg';
import error from 'assets/img/clint-mckoy.jpg';
import pricing from 'assets/img/bg-pricing.jpeg';
// import routes from "tvendo-routes"

import { RouteAction, useLayoutRoutes } from 'contexts/routeReducer';
import { WithApp } from 'contexts/appContext';
import { useCurrentRouteName } from 'contexts/routeReducer';

import  layoutRoutes from 'tvendo-routes';
const useStyles = makeStyles(styles);

export default WithApp(function Pages(props) {
  const { ...rest } = props;
  const location = useLocation();
  // const layoutPath = 'auth';
  const appContext = props.appContext;
  const { routeState, routeDispacher } = appContext;
  const routes = routeState.routes;
  // const layoutRoutes = useLayoutRoutes(routes, layoutPath);
   
  const router = useRoutes(layoutRoutes);
  // useEffect(() => {
  //   routeDispacher({ type: RouteAction.current, payload: location.pathname });
  // }, [location.pathname]);

  // ref for the wrapper div
  const wrapper = React.createRef();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = 'unset';
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const getBgImage = () => {
    if (location.pathname.indexOf('/auth/register-page') !== -1) {
      return register;
    } else if (location.pathname.indexOf('/auth/login-page') !== -1) {
      return login;
    } else if (location.pathname.indexOf('/auth/pricing-page') !== -1) {
      return pricing;
    } else if (location.pathname.indexOf('/auth/lock-screen-page') !== -1) {
      return lock;
    } else if (location.pathname.indexOf('/auth/error-page') !== -1) {
      return error;
    }
  };
  return (
    <div>
      <AuthNavbar brandText={useCurrentRouteName(routeState.paths, location.pathname)} {...rest} />
      {/* <AuthNavbar brandText={getActiveRoute(routes)} {...rest} /> */}
      <div className={classes.wrapper} ref={wrapper}>
        <div className={classes.fullPage} style={{ backgroundImage: 'url(' + getBgImage() + ')' }}>
          <Outlet />
          <Footer white />
        </div>
      </div>
    </div>
  );
});
